'use client';

import { RouteErrorFallback } from '@/components/error/RouteErrorFallback';

export default function PublicError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <RouteErrorFallback
      error={error}
      reset={reset}
      homeHref="/"
      homeLabel="Go Home"
      sectionLabel="this page"
      supportHref="mailto:support@eclipseaccounting.app"
    />
  );
}
